import React, {useState, useEffect,useRef } from 'react';
import AnnotationNamesConfig from '../../../AddInterpretation/AnnotationNamesConfig.js';
import AnnotationSectionsConfig from '../../../AddInterpretation/AnnotationSectionsConfig.js';
import { 
  TableBody,
  TableContainer,
  FormControlLabel,FormControl,FormLabel, Checkbox
} from '@mui/material';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../../../uiComponents/MuiTable/StyledTable.js';
import MuiTableHeader from '../../../../uiComponents/MuiTable/MuiTableHeader';
import muiCheckboxStyles from '../../../../uiComponents/MuiInput/MuiCheckboxStyles.js';
import ReviewStatus from '../../../../config/ReviewStatus.js';
import './index.css';

export default function ConsensusCategoryTable(props) {
  const [tableData, setTableData] = useState(props.data);
  const readyForConsensus = props.reviewStatus === ReviewStatus.READY_FOR_CONSENSUS ? true : false;
  const closed = props.reviewStatus === ReviewStatus.CLOSED ? true : false;
  const final = "FINAL@CDC.GOV";
  const [evalValue, setEvalValue] = useState({});
  const checkboxClasses = muiCheckboxStyles();
  
  //initialize saved final eval data based on finalVarInterp prop
  useEffect(() => { 
    if (!readyForConsensus & !closed) {
      setEvalValue(props.finalVarInterp);
    }
  }, [props.finalVarInterp] );

  //intialize tableData
  useEffect(() => { 
    setTableData(props.data);
  }, [props.data] );

  //initialize calculated final eval data based on form values
  useEffect(() => {
    if (readyForConsensus) {
      setEvalValue(props.formValues);
    }
  }, [props.formValues])

  //Important: The id here must match the column name in the returned data. Label can be different for display.
  const columns = [
    {label: 'Reviewer', id: 'sortName', type: 'noSort', numeric: false, disablePadding: false},
  ];

  Object.entries(AnnotationNamesConfig).forEach(([annotation, annotationString]) => {
    columns.push({label:annotationString,id:annotation, type: 'noSort', numeric:false, disablePadding:false});
  })

  const categoryTableCell = (row, category) => {
    if (!closed && row.userId === final) {
      return (
        // evaluationCell(row, category)
        <FormControl fullWidth>
          <FormLabel  id={"finalEvaluationFor_" + category}
            component="legend"
            className={checkboxClasses.formLabel}
            style={{ color: 'var(--alt-black)' }}
            // ref={selectCategory} // Attach ref here
          >
            Evaluation Criteria
          </FormLabel>
          {renderCheckboxItems(row, category)}
        </FormControl>
      );
    }

    var value = row[category] 
      ? (Array.isArray(row[category]["evaluation"]) ? (row[category]["evaluation"]).join(', ') : (row[category]["evaluation"]))
      : '';
    return (
      <>
      <div className='rowGroup'>{value}</div>
      {row[category] ? row[category]["comment"] : ''}
      </>
    )
  }

  const onEvaluationCheckboxChange = (event,category) =>  {
    const value = event.target.value;
    const currentValue = evalValue[category] || [];
    const newValue = currentValue.includes(value) ? currentValue.filter((item) => item !== value) : [...currentValue, value];
    setEvalValue((prev) => {
      const updatedValue = { ...prev, [category]: newValue };
      props.onEvaluationChange(updatedValue); 
      return updatedValue;
    });
    setTimeout(() => {
      console.log("after setEvalValue evalValue: ", evalValue);
    }, 0);
  } 

  const renderCheckboxItems = (row, selectCategory) => {
    let isFirstCheckbox = true; // Track the first checkbox
    let categoryEnum = selectCategory;
    //compare the current enum to the category string list
    let categoryName = AnnotationNamesConfig[categoryEnum];
    let annotationSections = AnnotationSectionsConfig[categoryName];
    if (annotationSections != null) {
      let value = annotationSections["categories"];

      return value.map(category => {
        const checked = props.formValues[selectCategory] != null ? props.formValues[selectCategory].includes(category.name) : false;
        const disabled = props.formValues[selectCategory]?.length > 0 ? category.name.charAt(0) !== props.formValues[selectCategory][0]?.charAt(0) : false;

        return (
          <FormControlLabel
            key={category.name}
            classes={{ label: checkboxClasses.checkboxLabel }}
            control={
              <Checkbox
                className={checkboxClasses.checkboxRoot} 
                name={category.name}
                classes={{
                  root: checked ? checkboxClasses.checkboxSelected : checkboxClasses.checkboxRoot,
                }}
                disabled={disabled}
                value={category.name}
                checked={checked}
                onChange={(event)=> onEvaluationCheckboxChange(event, selectCategory)}
              />
            }
            label={category.name}
          />
        );
      })
    };
  }

  return (
    <section>
       <h2 className="sectionHeading">Summary of Variant Interpretation Results</h2>
       <div className="sectionContent">
        <StyledPaper>
          <TableContainer>
            <StyledTable
              size='small'
              aria-label="consensus category table">
              <MuiTableHeader 
                headCells={columns} 
              />
              <TableBody>
                {/* set table data default sort before render since this table should not be sortable by user, move final review to bottom of table */}
                {tableData.sort((a,b) => {
                  if (a.userId === final && b.userId !== final) {
                    return 1;
                  } else if (a.userId !== final && b.userId === final) {
                    return -1;
                  } else {
                    return a.sortName.localeCompare(b.sortName);
                  }
                }).map((row) => {
                  return (
                    <StyledTableRow tabIndex={-1} key={row.userId}>
                      <StyledTableCell style={{ width: '15%' }}>{row.sortName}</StyledTableCell>
                      <StyledTableCell style={{ width: '17%', verticalAlign: 'top' }}>
                        {categoryTableCell(row, 'POPULATION_FREQUENCY')}
                      </StyledTableCell>
                      <StyledTableCell style={{ width: '17%', verticalAlign: 'top' }}>
                        {categoryTableCell(row, 'DISEASE_DATABASES')}
                      </StyledTableCell>
                      <StyledTableCell style={{ width: '17%', verticalAlign: 'top' }}>
                        {categoryTableCell(row, 'COMPUTATIONAL_PREDICTIVE_PROGRAMS')}
                      </StyledTableCell>
                      <StyledTableCell style={{ width: '17%', verticalAlign: 'top' }}>
                        {categoryTableCell(row, 'NUCLEOTIDE_CONSERVATION')}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </StyledTable>
          </TableContainer>
        </StyledPaper>
      </div>
    </section>
  );
}
